import { render, staticRenderFns } from "./detailSanitaire.vue?vue&type=template&id=0ed763c5&scoped=true"
import script from "./detailSanitaire.vue?vue&type=script&lang=js"
export * from "./detailSanitaire.vue?vue&type=script&lang=js"
import style0 from "./detailSanitaire.vue?vue&type=style&index=0&id=0ed763c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed763c5",
  null
  
)

export default component.exports